<template>
  <v-navigation-drawer v-model="isSidebarActiveLocal" absolute temporary width="300" right>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <v-card class="mb-7">
        <v-card-text class="pa-5 ">
          <div class="d-flex align-center text-center">
            <h3 class="title orange--text">{{title}}</h3>
          </div>

          <v-row class="mt-3">
            <v-col cols="12">
              <ValidationProvider rules="required|digits_between:4" v-slot="{ errors }" name="name">
                <v-text-field
                        label="Nome"
                        :error-messages="errors"
                        v-model="role.name"
                        rel="initialFocus"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{ errors }" name="color">
                <v-text-field
                        v-model.trim="role.alias"
                        label="Alias"
                        :error-messages="errors"
                >
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{ errors }" name="parent">

                <v-text-field
                        v-model="role.description"
                        label="Descrição"
                        :error-messages="errors"
                >
                </v-text-field>

              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>
        <div  class="text-center">
          <buttons-form-side @onCreateSubmit="passes(createSubmit)" @onUpdateSubmit="passes(updateSubmit)" @cancel="cancelar"  :operation="operation" ></buttons-form-side>
        </div>
      </v-card>
    </ValidationObserver>
  </v-navigation-drawer>
</template>
<script>
    import { CreateMutation, UpdateMutation } from '@/graphql/mutations/Role.gql'
    import ButtonsFormSide from "@/components/appComponents/ButtonsFormSide";
    import { ValidationObserver, ValidationProvider } from "vee-validate";
    export default {
        name: "Roleform",
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true,
            },
            title: {
                type: String,
            },
            data: {
                type: Object,
                required: true,
            },
            operation: {
                type: String,
                required: true,
            },
        },
        components: {
            ValidationObserver,
            ValidationProvider,
         ButtonsFormSide
        },
        data: () => {
            return {
                role: {},
                menu: false,
                parent:null,
            };
        },

        computed: {

            isSidebarActiveLocal: {

                get() {
                    this.setLocalData();
                    return this.isSidebarActive;
                },
                set(val) {
                    if (!val) {
                        this.$emit("closeSidebar");
                    }
                },
            },
            dataSubmit() {
                const data = {
                    name: this.role.name,
                    alias: this.role.alias,
                    description: this.role.description
                }
                return data;
            },
        },
        methods: {
         cancelar(valor){
          this.isSidebarActiveLocal = valor
         },
            setLocalData() {
                this.role = this.data;
            },
            clear() {
                this.isSidebarActiveLocal = false;
            },
            createSubmit() {
                this.$apollo
                    .mutate({
                        mutation: CreateMutation,
                        variables: {
                            ...this.dataSubmit,
                        },
                    })
                    .then(() => {
                        this.$toasted.global.defaultSuccess();
                        this.$emit("reload-list");
                        this.clear();
                    })
                  .catch(({graphQLErrors}) => {
                    if(graphQLErrors[0].debugMessage ){
                     this.$toasted.global.defaultError('alias já existe');
                    }
                  })
            },
            updateSubmit() {
                this.$apollo
                    .mutate({
                        mutation: UpdateMutation,
                        variables: {
                            id: this.role.id,
                            ...this.dataSubmit,
                        },
                    })
                    .then(() => {
                        this.$toasted.global.defaultSuccess();
                        this.$emit("reload-list");
                        this.clear();
                    })
                    .catch((error) => {
                        this.$toasted.global.defaultError({ error });
                        console.error(error);
                    });
            },
        },
        apollo: {
            labels: {
                query: require('@/graphql/queries/Label.gql').getLabels,
                update: (data) => data.labels
            }
        },
        mounted() {
            this.$el.querySelector("input").focus();
        },
    };
</script>